import { useState } from "react";
import TruncateMarkup from "react-truncate-markup";
import styles from './styles.module.scss';
import parse from "html-react-parser";
import { Language } from 'providers/translates/enums';
import { getArtificialBlockSetting } from "components/CreateMemorialQuiltComponents/DialogBlocks/utils";
import { useTranslates } from "providers/translates";

type Props = {
  isTopContent?: boolean;
  isFullText?: boolean;
  content: string;
}

export const VISIBLE_HEIGHT = 250;

const ReadMore: React.FC<Props> = ({
  isTopContent,
  isFullText = false,
  content
}) => {
  const { selectedLang } = useTranslates();
  const isFrench = selectedLang === Language.FRENCH;
  
  const [showSettings, setShowSettings] = useState(() => {
    if (getArtificialBlockSetting(content, isFullText).height >= VISIBLE_HEIGHT) {
      return {
        isShowReadLess: true,
        isShow: true,
      };
    }

    return {
      isShowReadLess: false,
      isShow: false,
    }
  });

  return (
    <div className={styles.textBlock}>
      <TruncateMarkup 
        lines={showSettings.isShowReadLess ? 10 : 1000}
        ellipsis=""
      >
        <div
          className={isTopContent ? '' : `${styles.textBlock__content} textForPrint`}
          style={{
            wordBreak: 'break-word',
            overflowWrap: 'break-word',
            whiteSpace: 'normal'
          }}
        >{parse(content)}</div>
      </TruncateMarkup>
      {showSettings.isShow && (
        <div
          className={styles.read}
          onClick={() => setShowSettings(prev => ({...prev, isShowReadLess: !prev.isShowReadLess}))}
        >
          {isFrench ? (
            showSettings.isShowReadLess ? 'Voir plus' : 'Voir moins'
          ) : (
            showSettings.isShowReadLess ? 'Read more' : 'Show less'
          )}
        </div>
      )}
    </div>
  );
}

export { ReadMore };